export default function Features() {
  return (
    <section id="features" className="relative bg-white py-32">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex gap-8">
          <div className="w-3/5 pr-12">
            <div className="text-sm font-medium text-gray-600 mb-12">• User Feedback</div>
            <blockquote className="text-6xl font-serif text-[#0D0D0D] leading-tight mb-12">
              "The VPN service transformed my mobile security experience completely"
            </blockquote>
            <div className="flex items-center gap-3">
              <span className="text-lg font-semibold text-gray-900">Michael Chen</span>
              <div className="flex items-center gap-2 bg-teal-500 text-white px-3 py-1 rounded-full">
                <i className="ri-star-fill text-sm"></i>
                <span className="text-xs font-medium">App Store Review</span>
              </div>
            </div>
          </div>

          <div className="w-2/5">
            <div className="h-[520px] rounded-2xl overflow-hidden">
              <img 
                src="https://public.readdy.ai/ai/img_res/bb8d0835c6fdf8d6deaecb3e07be055b.jpg"
                alt="User testimonial"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="mt-32">
          <div className="rounded-3xl overflow-hidden mb-12">
            <img 
              src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20representation%20of%20digital%20security%20and%20data%20protection%20featuring%20lock%20mechanisms%20and%20encrypted%20data%20streams%20in%20sophisticated%20blue-gray%20tones%2C%20modern%20cybersecurity%20visualization%20with%20geometric%20patterns%20and%20network%20connections%2C%20professional%20tech%20aesthetic%20with%20artistic%20grain%20texture%2C%20minimalist%20composition%20showing%20advanced%20protection%20technology%20and%20secure%20digital%20infrastructure&width=1100&height=580&seq=cta-security-visual&orientation=landscape"
              alt="Digital security"
              className="w-full h-full object-cover"
              style={{ height: '580px' }}
            />
          </div>

          <div className="text-center max-w-4xl mx-auto">
            <p className="text-4xl leading-relaxed mb-12">
              <span className="font-light italic text-gray-500">Experience </span>
              <span className="font-semibold text-[#0F0F0F]">seamless </span>
              <span className="font-light italic text-gray-500">protection with </span>
              <span className="font-semibold text-[#0F0F0F]">advanced </span>
              <span className="font-light text-gray-900">security solutions</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
